export default __webpack_public_path__ + "static/media/add-hours.7bbba5c0.svg";